import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';
import { Button, Icon } from 'Permafrost/index';
import { StyledNumberField } from './NumberField.styles';
/**
 * Basic numeric input field. A label is required, but may be visually hidden
 * using the `hiddenLabel` property.
 */
export function NumberField(props) {
    // ensures unique value to associate label with input
    const fieldId = uuid();
    const { autoFocus, className, disabled, hiddenLabel, id, label, max, min, onChange, placeholder, required, step, tabIndex, value, } = props;
    const [currentValue, setCurrentValue] = useState(value ? value : value === 0 ? 0 : '');
    const inputEl = useRef(null);
    const increment = () => {
        const input = inputEl.current;
        if (input) {
            input.stepUp();
            // convert string value to number
            setCurrentValue(+input.value);
        }
        if (props.increment)
            props.increment();
    };
    const decrement = () => {
        const input = inputEl.current;
        if (input) {
            input.stepDown();
            // convert string value to number
            setCurrentValue(+input.value);
        }
        if (props.decrement)
            props.decrement();
    };
    const handleChange = (event) => {
        var _a;
        const targetValue = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
        setCurrentValue(targetValue === '' ? '' : +targetValue);
    };
    // When external state changes, we update local state to match, if not already
    useEffect(() => {
        if (currentValue === value) {
            return;
        }
        setCurrentValue(value);
    }, [value]);
    // todo: this is problematic because it means on mount the onChange handler will always be fired
    // therefore - if the onChange is some heavy operation or call to the BE - that will automatically get called
    // without the user even doing anything
    useEffect(() => {
        // We must debounce the min/max evaluation until after the user has finished typing
        const delayDebounceFn = setTimeout(() => {
            if ((min || min === 0) && +currentValue < min) {
                setCurrentValue('');
                onChange('');
            }
            else if ((max || max === 0) && +currentValue > max) {
                setCurrentValue('');
                onChange('');
            }
            else if (+currentValue < 0) {
                setCurrentValue('');
                onChange('');
            }
            else {
                onChange(currentValue);
            }
        }, 1000);
        return () => clearTimeout(delayDebounceFn);
    }, [currentValue]);
    return (React.createElement(StyledNumberField, { className: classNames(className, {
            hiddenLabel,
        }), "data-cy": props['data-cy'], id: id },
        React.createElement("input", { "data-testid": props['data-testid'], tabIndex: tabIndex, autoFocus: autoFocus, id: fieldId, type: "number", value: currentValue, disabled: disabled, max: max, min: min, onChange: handleChange, placeholder: placeholder, required: required, step: step, "aria-label": hiddenLabel ? label : '', ref: inputEl }),
        !hiddenLabel && React.createElement("label", { htmlFor: fieldId }, label),
        React.createElement("div", { className: "spin-buttons" },
            React.createElement(Button, { variant: "no-style", onClick: increment, tabindex: -1 },
                React.createElement(Icon, { name: "fa-caret-up", ariaLabel: "increase" })),
            React.createElement(Button, { variant: "no-style", onClick: decrement, tabindex: -1 },
                React.createElement(Icon, { name: "fa-caret-down", ariaLabel: "decrease" })))));
}
//# sourceMappingURL=NumberField.js.map